module.exports = __webpack_public_path__ + "img/ingredienten-tofu-gehaktburgers.14753f62.jpeg";